import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faPenToSquare, faTrashCan, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useParams } from 'react-router-dom';
import './UpdateAssessment.css';

const config=require( '../../config.js');

function UpdateAssessment() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [assessment, setAssessment] = useState(null);
    const [questionPop, setQuestionPop] = useState(false);
    const [exam, setExam] = useState(true);
    const [question, setQuestion] = useState(false);
    const [editingQuestion, setEditingQuestion] = useState(null); // State for editing question

    const fetchAssessment = async () => {
        console.log(`Fetching assessment with ID: ${id}`);
            try {
                const response = await fetch(config.env.API_BASE_URL+`/api/assessments/${id}`, {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token')
                    }
                });
                if (response.ok) {
                    const data = await response.json();
                    setAssessment(data);
                } else {
                    console.error('Failed to fetch assessment');
                }
            } catch (error) {
                console.error('Error fetching assessment:', error);
            }
    };

    useEffect(() => {
        fetchAssessment(); // Fetch assessments on component mount
    }, [id]);

    const showExam = () => {
        setExam(true);
        setQuestion(false);
    };

    const showQuestions = () => {
        setQuestion(true);
        setExam(false);
    };

    const addQuestion = (newQuestion) => {
        setAssessment({
            ...assessment,
            questions: [...assessment.questions, newQuestion]
        });
        setQuestionPop(false);
    };

    const updateQuestion = (updatedQuestion) => {
        setAssessment({
            ...assessment,
            questions: assessment.questions.map(q => q._id === updatedQuestion._id ? updatedQuestion : q)
        });
        setQuestionPop(false);
        setEditingQuestion(null);
    };

    if (!assessment) {
        return <div>Loading...</div>;
    }

    const handleCopy = async (assessment, question) => {
        const newQuestion = {
            questionID: "Copy of " + question.questionID,
            question: question.question,
            questionType: question.questionType,
            questionCategory: question.questionCategory,
            nextQuestions: question.nextQuestions,
            nextQIfSkipped: question.nextQIfSkipped,
            requireForEvaluation: question.requireForEvaluation,
            doNotSave: question.doNotSave,
            disclaimer: question.disclaimer,
            alertText: question.alertText,
            notifytext: question.notifytext,
            notifynottext: question.notifynottext,
            calculation: question.calculation,
            options: question.options,
            optionsWithFlag: question.optionsWithFlag,
            examName: assessment.examName,
            examCategory: assessment.examCategory
        };

        try {
            const response = 
                await fetch(config.env.API_BASE_URL+`/api/assessments/${id}/questions`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('token')
                    },
                    body: JSON.stringify(newQuestion),
                });

            if (response.ok) {
                alert('Question copied successfully!');
                fetchAssessment(); // Fetch assessments after copying
            } else {
                console.error('Failed to copy question');
            }
        } catch (error) {
            console.error('Error copying question:', error);
        }
    };

    const handleAddQuestion = () => {
        setQuestionPop(true);
        setEditingQuestion(null); // Clear editing state
    };

    const handleEditQuestion = (question) => {
        setEditingQuestion(question);
        setQuestionPop(true);
    };

    const deleteQuestion = async (questionId) => {
        try {
            const response = await fetch(config.env.API_BASE_URL+`/api/assessments/${assessment._id}/questions/${questionId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            });

            if (response.ok) {
                setAssessment({
                    ...assessment,
                    questions: assessment.questions.filter(q => q._id !== questionId)
                });
            } else {
                console.error('Failed to delete question');
            }
        } catch (error) {
            console.error('Error deleting question:', error);
        }
    };

    return (
        <>
            <div className='container' style={{scroll: 'overflow'}}>
                <h2 className='text-start mt-5'>Edit Exam</h2>
                <hr />

                <section className='Edit-buttons'>
                    <div className={`slider ${exam ? 'left' : 'right'}`}></div>
                    <button className={exam ? 'active' : ''} onClick={showExam}>Exam Details</button>
                    <button className={question ? 'active' : ''} onClick={showQuestions}>Questions</button>
                </section>

                {exam && <EditDetails examName={assessment.examName} examCategory={assessment.examCategory} languageselected={assessment.language} assessmentId={assessment._id} evaluateAsMSS={assessment.isMSS} />}
                {question &&
                    <>
                        <div className='d-flex container justify-content-end'>
                            <button className='btn-Create mt-3' onClick={handleAddQuestion}>Add Question</button>
                        </div>
                        <div className='mt-5 Crud-main-container container'>
                            <table className="table Crud-main container">
                                <thead>
                                    <tr className="Crud-thead-wrapper">
                                        <th scope="col">Question ID</th>
                                        <th scope="col">Question</th>
                                        <th scope="col">Question Type</th>
                                        <th scope="col">Question Category</th>
                                        <th scope="col">Next Questions</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {assessment.questions.map((question, index) => (
                                        <tr key={index}>
                                            <td>{question.questionID}</td>
                                            <td>{question.question}</td>
                                            <td>{question.questionType}</td>
                                            <td>{question.questionCategory}</td>
                                            <td>{question.nextQuestions}</td>
                                            <td>
                                                <FontAwesomeIcon className='icon' icon={faPenToSquare} onClick={() => handleEditQuestion(question)} />
                                                <FontAwesomeIcon
                                                    onClick={() => handleCopy(assessment, question)}
                                                    className='icon'
                                                    icon={faCopy}
                                                />
                                                <FontAwesomeIcon
                                                    className='icon trash'
                                                    icon={faTrashCan}
                                                    onClick={() => {
                                                        if (window.confirm('Are you sure you want to delete this question?')) {
                                                          deleteQuestion(question._id);
                                                        }
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                }
            </div>
            {questionPop && <AddQuestion setQuestionPop={setQuestionPop} addQuestion={addQuestion} updateQuestion={updateQuestion} editingQuestion={editingQuestion} />}
        </>
    );
}

export default UpdateAssessment;

const EditDetails = ({ examName, examCategory, languageselected, assessmentId, evaluateAsMSS }) => {
    const [name1, setName1] = useState(examName);
    const [name2, setName2] = useState(examCategory);
    const [isMSS, setIsMSS] = useState(evaluateAsMSS);
    const [language, setLanguage] = useState(languageselected);
    const navigate = useNavigate();

    const clearInput1 = () => setName1('');
    const clearInput2 = () => setName2('');

    const handleSave = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(config.env.API_BASE_URL+`/api/assessments/${assessmentId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify({ examName: name1, examCategory: name2, language: language, isMSS: isMSS }),
            });

            if (response.ok) {
                alert('Assessment updated successfully');
                navigate('/assessment');
            } else {
                const errorData = await response.json();
                console.error('Failed to update assessment:', errorData.message);
            }
        } catch (error) {
            console.error('Error updating assessment:', error);
        }
    };


    return (
        <>
            <div className='container'>
                <section className='form-create'>
                    <form onSubmit={handleSave}>
                        <div className={`input-wrap ${name1 ? 'has-value' : ''}`}>
                            <input
                                type='text'
                                className='input1'
                                value={name1}
                                onChange={(e) => setName1(e.target.value)}
                            />
                            <label>Exam Name</label>
                            {name1 && (
                                <button type="button" className="clear-button" onClick={clearInput1}>
                                    <FontAwesomeIcon className='input-close-icon' icon={faCircleXmark} />
                                </button>
                            )}
                        </div>


                        <div className={`input-wrap ${name2 ? 'has-value' : ''}`}>
                            <input
                                type='text'
                                className='input2'
                                value={name2}
                                onChange={(e) => setName2(e.target.value)}
                            />
                            <label>Exam Category</label>
                            {name2 && (
                                <button type="button" className="clear-button" onClick={clearInput2}>
                                    <FontAwesomeIcon className='input-close-icon' icon={faCircleXmark} />
                                </button>
                            )}
                        </div>

                        <div className={`input-wrap ${language ? 'has-value' : ''}`}>
                            <select className='input3' value={language} onChange={(e) => setLanguage(e.target.value)}>
                                <option className='d-none text-secondary' value=""></option>
                                <option value="english">English</option>
                                <option value="german">German</option>
                                <option value="czech">Czech</option>
                                <option value="italian">Italian</option>
                            </select>
                            <label className='text-secondary'>Language <span className='text-danger'>*</span></label>
                        </div>

                        <div className="checkbox-label-wrapper">
                            <div className="checkbox-label-mss">Evaluate as MSS:</div>
                                <input 
                                    type="checkbox" 
                                    id="checkboxNA" 
                                    className="form-check-input"
                                    checked={isMSS} 
                                    onChange={(e) => {setIsMSS(e.target.checked)}} 
                                />
                         </div>

                        <div className='d-flex justify-content-between mt-3'>
                            <button type="button" onClick={() => navigate('/assessment')} className='btn-cancel'>Cancel</button>
                            <button type="submit" className='btn-Create'>Save</button>
                        </div>
                    </form>
                </section>
            </div>

        </>
    );
};

const AddQuestion = ({ setQuestionPop, addQuestion, updateQuestion, editingQuestion }) => {
    const { id } = useParams();
    const [name1, setName1] = useState(editingQuestion ? editingQuestion.questionID : '');
    const [name2, setName2] = useState(editingQuestion ? editingQuestion.question : '');
    const [name5, setName5] = useState(editingQuestion ? editingQuestion.nextQuestions : '');
    const [requireForEvaluation, setRequireForEvaluation] = useState(
        editingQuestion && editingQuestion.hasOwnProperty('requireForEvaluation')
            ? editingQuestion.requireForEvaluation
            : true
    );
    const [doNotSave, setDoNotSave] = useState(
        editingQuestion && editingQuestion.hasOwnProperty('doNotSave')
            ? editingQuestion.doNotSave
            : false
    );
    const [nextQIfSkipped, setNextQIfSkipped] = useState(editingQuestion ? editingQuestion.nextQIfSkipped : '');
    const [name6, setName6] = useState(editingQuestion ? editingQuestion.disclaimer : '');
    const [name7, setName7] = useState(editingQuestion ? editingQuestion.alertText : '');
    const [name8, setName8] = useState(editingQuestion ? editingQuestion.notifytext : '');
    const [name9, setName9] = useState(editingQuestion ? editingQuestion.notifynottext : '');
    const [calculation, setCalculation] = useState(editingQuestion ? editingQuestion.calculation : '');
    const [options, setOptions] = useState(editingQuestion ? editingQuestion.options || [] : []);
    const [optionsWithFlag, setOptionsWithFlag] = useState(() => {
        return editingQuestion?.optionsWithFlag?.map(option => ({
            value: option?.value ?? '',
            flag: option?.flag !== undefined ? option.flag : undefined
        })) || [];
    });
    const [questionType, setQuestionType] = useState(editingQuestion ? editingQuestion.questionType : '');
    const [questionCategory, setQuestionCategory] = useState(editingQuestion ? editingQuestion.questionCategory : '');
    const [examDetails, setExamDetails] = useState({});

    useEffect(() => {
        const fetchExamDetails = async () => {
            try {
                const response = await fetch(config.env.API_BASE_URL+`/api/assessments/${id}`, {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token')
                    }
                });
                if (response.ok) {
                    const data = await response.json();
                    setExamDetails({ examName: data.examName, examCategory: data.examCategory });
                } else {
                    console.error('Failed to fetch exam details');
                }
            } catch (error) {
                console.error('Error fetching exam details:', error);
            }
        };

        fetchExamDetails();
    }, [id]);

    const clearInput = (setFunction) => () => setFunction('');

    const handleOptionChangeWithFlag = (index, newValue, newFlag) => {
        setOptionsWithFlag(prevOptions => {
            const newOptions = [...prevOptions];
            newOptions[index] = { ...newOptions[index], value: newValue, flag: newFlag };
            return newOptions;
        });

        // Still save changes in previous structure until frontend is tested
        const newOptions = [...options];
        newOptions[index] = newValue;
        setOptions(newOptions);
    };

    const checkFlagByValue = (valueToCheck) => {
        const option = optionsWithFlag.find(savedOption => 
            savedOption && savedOption.value !== undefined && savedOption.value === valueToCheck
        );
        return option ? option.flag : undefined;
    };

    const handleSubmit = async () => {
        const newQuestion = {
            questionID: name1,
            question: name2,
            questionType,
            questionCategory,
            nextQuestions: name5,
            nextQIfSkipped,
            requireForEvaluation,
            doNotSave,
            disclaimer: name6,
            alertText: name7,
            notifytext: name8,
            notifynottext: name9,
            calculation,
            options: questionType === "Calculation" || questionType === "MCQ" || questionType === "MCQ-AfterMultiple" || questionType === "Multiple Select" || questionType === "Radio Buttons" || questionType === "Input Validation" ? options : [],
            optionsWithFlag: questionType === "Calculation" || questionType === "MCQ" || questionType === "MCQ-AfterMultiple" || questionType === "Multiple Select" || questionType === "Radio Buttons" || questionType === "Input Validation" ? optionsWithFlag : [],
            examName: examDetails.examName,
            examCategory: examDetails.examCategory
        };

        try {
            console.log(editingQuestion);
            const response = editingQuestion ?
                await fetch(config.env.API_BASE_URL+`/api/assessments/${id}/questions/${editingQuestion._id}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('token')
                    },
                    body: JSON.stringify(newQuestion),
                })
                :
                await fetch(config.env.API_BASE_URL+`/api/assessments/${id}/questions`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('token')
                    },
                    body: JSON.stringify(newQuestion),
                });

            if (response.ok) {
                editingQuestion ? updateQuestion({ ...newQuestion, _id: editingQuestion._id }) : addQuestion(newQuestion);
                setQuestionPop(false);
            } else {
                console.error('Failed to save question');
            }
        } catch (error) {
            console.error('Error saving question:', error);
        }
    };


    const canAddOption = (questionType === "MCQ" && options.length < 30) || (questionType === "Calculation" && options.length < 30) || (questionType === "MCQ-AfterMultiple" && options.length < 2) || (questionType === "Multiple Select" && options.length < 30) || (questionType === "Radio Buttons" && options.length < 30) || (questionType === "Input Validation" && options.length < 2);

    return (
        <section className='add-question-main' sytle="overflow: scroll">
            <section className='form-input'>
                <form>
                    <h4>{editingQuestion ? 'Edit Question' : 'Add Question'}</h4>
                    <div className={`input-wraps ${name1 ? 'has-values' : ''}`}>
                        <input type='text' className='input-1' value={name1} onChange={(e) => setName1(e.target.value)} />
                        <label>Question ID <span className='text-danger'>*</span></label>
                        {name1 && <button type="button" className="clear-buttons" onClick={clearInput(setName1)}>
                            <FontAwesomeIcon className='input-close-icons' icon={faCircleXmark} />
                        </button>}
                    </div>

                    <div className={`input-wraps ${name2 ? 'has-values' : ''}`}>
                        <textarea className='input-2' value={name2} onChange={(e) => setName2(e.target.value)}></textarea>
                        <label>Question <span className='text-danger'>*</span></label>
                        {name2 && <button type="button" className="clear-buttons" onClick={clearInput(setName2)}>
                            <FontAwesomeIcon className='input-close-icons' icon={faCircleXmark} />
                        </button>}
                    </div>

                    <div className={`input-wraps ${questionType ? 'has-values' : ''}`}>
                        <select className='input-3' value={questionType} onChange={(e) => setQuestionType(e.target.value)}>
                            <option className='d-none' value=""></option>
                            <option value="MCQ">MCQ</option>
                            <option value="MCQ-AfterMultiple">MCQ-AfterMultiple</option>
                            <option value="Radio Buttons">Radio Buttons</option>
                            <option value="Short">Short</option>
                            <option value="Long Text">Long Text</option>
                            <option value="Input Validation">Input Validation</option>
                            <option value="Numerical Value">Numerical Value</option>
                            <option value="Multiple Select">Multiple Select</option>
                            <option value="Year">Fiscal Year</option>
                            <option value="examDescription">Activity Name</option>
                            <option value="Calculation">Calculation</option>
                            <option value="File">File</option>
                            <option value="Blank">Blank</option>
                        </select>
                        <label>Question Type <span className='text-danger'>*</span></label>
                    </div>

                    <div className={`input-wraps ${questionCategory ? 'has-values' : ''}`}>
                        <select className='input-3' value={questionCategory} onChange={(e) => setQuestionCategory(e.target.value)}>
                            <option className='d-none' value=""></option>
                            <option value="Substantial Contribution">Substantial Contribution</option>
                            <option value="DNSH - Adaptation">DNSH - Adaptation</option>
                            <option value="DNSH - Biodiversity">DNSH - Biodiversity</option>
                            <option value="DNSH - Water">DNSH - Water</option>
                            <option value="DNSH - Circular Economy">DNSH - CE</option>
                            <option value="DNSH - Pollution">DNSH - Pollution</option>
                            <option value="Fiscal Year">Fiscal Year</option>
                            <option value="Turnover">Turnover</option>
                            <option value="CapEx">CapEx</option>
                            <option value="OpEx">OpEx</option>

                            <option value="Blank">Blank</option>
                        </select>
                        <label>Question Category <span className='text-danger'>*</span></label>
                    </div>

                    {(questionCategory === "Substantial Contribution" || questionCategory === "DNSH - Adaptation" || questionCategory === "DNSH - Biodiversity" || questionCategory === "DNSH - Water" || questionCategory === "DNSH - Circular Economy" || questionCategory === "DNSH - Pollution") && (questionType === "Long Text") && (
                        <div className={`${requireForEvaluation ? 'has-values' : ''}`}>
                            <div className="checkbox-label-wrapper">
                                <input id="requireForEvaluationCheckbox" type="checkbox" className="form-check-input" checked={requireForEvaluation} onChange={(e) => setRequireForEvaluation(e.target.checked)} />
                                <label className="checkbox-label" for="requireForEvaluationCheckbox">Require answer for category evaluation</label>
                            </div>
                        </div>
                     )}

                    <div className={`input-wraps ${name5 ? 'has-values' : ''}`}>
                        <input type='text' className='input-5' value={name5} onChange={(e) => setName5(e.target.value)} />
                        <label>Next Question</label>
                        {name5 && <button type="button" className="clear-buttons" onClick={clearInput(setName5)}>
                            <FontAwesomeIcon className='input-close-icons' icon={faCircleXmark} />
                        </button>}
                    </div>

                    {(name5 === "end") && (
                        <div className={`${doNotSave ? 'has-values' : ''}`}>
                            <div className="checkbox-label-wrapper">
                                <input id="doNotSaveCheckbox" type="checkbox" className="form-check-input" checked={doNotSave} onChange={(e) => setDoNotSave(e.target.checked)} />
                                <label className="checkbox-label" for="doNotSaveCheckbox">Don't allow saving the assessment.</label>
                            </div>
                        </div>
                    )}

                    {(questionType === "Multiple Select") && (
                        <div className={`input-wraps ${nextQIfSkipped ? 'has-values' : ''}`}>
                            <input type='text' className='input-5' value={nextQIfSkipped} onChange={(e) => setNextQIfSkipped(e.target.value)} />
                            <label>Next question if no option was selected</label>
                            {nextQIfSkipped && <button type="button" className="clear-buttons" onClick={clearInput(setNextQIfSkipped)}>
                                <FontAwesomeIcon className='input-close-icons' icon={faCircleXmark} />
                            </button>}
                        </div>
                    )}
                    
                    <div className={`input-wraps ${name6 ? 'has-values' : ''}`}>
                        <input type='text' className='input-5' value={name6} onChange={(e) => setName6(e.target.value)} />
                        <label>Add Disclaimers</label>
                        {name6 && <button type="button" className="clear-buttons" onClick={clearInput(setName6)}>
                            <FontAwesomeIcon className='input-close-icons' icon={faCircleXmark} />
                        </button>}
                    </div>


                    <div className={`input-wraps ${name7 ? 'has-values' : ''}`}>
                        <input type='text' className='input-5' value={name7} onChange={(e) => setName7(e.target.value)} />
                        <label>Alert if not answered</label>
                        {name7 && <button type="button" className="clear-buttons" onClick={clearInput(setName7)}>
                            <FontAwesomeIcon className='input-close-icons' icon={faCircleXmark} />
                        </button>}
                    </div>

                    <div className={`input-wraps ${name8 ? 'has-values' : ''}`}>
                        <input type='text' className='input-5' value={name8} onChange={(e) => setName8(e.target.value)} />
                        <label>Notify If answered</label>
                        {name8 && <button type="button" className="clear-buttons" onClick={clearInput(setName8)}>
                            <FontAwesomeIcon className='input-close-icons' icon={faCircleXmark} />
                        </button>}
                    </div>

                    <div className={`input-wraps ${name9 ? 'has-values' : ''}`}>
                        <input type='text' className='input-5' value={name9} onChange={(e) => setName9(e.target.value)} />
                        <label>Notify If not answered</label>
                        {name9 && <button type="button" className="clear-buttons" onClick={clearInput(setName9)}>
                            <FontAwesomeIcon className='input-close-icons' icon={faCircleXmark} />
                        </button>}
                    </div>

                    {(questionType === "Calculation") && (
                    <div className={`input-wraps ${calculation ? 'has-values' : ''}`}>
                        <input type='text' className='input-5' value={calculation} onChange={(e) => setCalculation(e.target.value)} />
                        <label>Calculation Formula</label>
                        {calculation && <button type="button" className="clear-buttons" onClick={clearInput(setCalculation)}>
                            <FontAwesomeIcon className='input-close-icons' icon={faCircleXmark} />
                        </button>}
                    </div>)}

                    {(questionType === "MCQ" || questionType === "Multiple Select" || questionType === "Calculation" || questionType === "Radio Buttons" || questionType === "Input Validation" || questionType === "MCQ-AfterMultiple") && (
                        <div className='msq-options'>
                            {options.map((option, index) => (
                                <div className='d-flex flex-column m-1' key={index}>
                                    <div className={`input-wraps ${option ? 'has-values' : ''}`}>
                                        <input 
                                            type='text' 
                                            className={`option-input-${index + 1}`} 
                                            value={option} 
                                            onChange={(e) => handleOptionChangeWithFlag(index, e.target.value, option.flag)}/>
                                        <label>{String.fromCharCode(65 + index)}</label>
                                        {option && <button type="button" className="clear-buttons" onClick={() => handleOptionChangeWithFlag(index, '', undefined)
                                        }>
                                            <FontAwesomeIcon className='input-close-icons' icon={faCircleXmark} />
                                        </button>}
                                    </div>
                                    {option && questionType != "Calculation" && 
                                        <div className="checkbox-label-wrapper mt-2">
                                            <div className="mb-2">Fulfills criteria:</div>
                                            <div className="d-flex">
                                                <div className="checkbox-label-wrapper">
                                                    <input 
                                                        type="checkbox" 
                                                        id="checkboxYes" 
                                                        className="form-check-input"
                                                        checked={checkFlagByValue(option) === true} 
                                                        onChange={(e) => handleOptionChangeWithFlag(index, option, e.target.checked ? true : undefined)} 
                                                    />
                                                    <div className="checkbox-label">Yes</div>
                                                </div>
                                                <div className="checkbox-label-wrapper">
                                                    <input 
                                                        type="checkbox" 
                                                        id="checkboxNo" 
                                                        className="form-check-input"
                                                        checked={checkFlagByValue(option) === false} 
                                                        onChange={(e) => handleOptionChangeWithFlag(index, option, e.target.checked ? false : undefined)} 
                                                    />
                                                    <div className="checkbox-label">No</div>
                                                </div>
                                                <div className="checkbox-label-wrapper">
                                                    <input 
                                                        type="checkbox" 
                                                        id="checkboxNA" 
                                                        className="form-check-input"
                                                        checked={checkFlagByValue(option) === "Not Assessable"} 
                                                        onChange={(e) => handleOptionChangeWithFlag(index, option, "Not Assessable")} 
                                                    />
                                                    <div className="checkbox-label">Not Assessable</div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            ))}
                            <button type="button" onClick={() => canAddOption && setOptions([...options, '']) && setOptionsWithFlag([...optionsWithFlag, { value: '', flag: undefined }])} className='btn-add-option' disabled={!canAddOption}>Add Option</button>
                        </div>
                    )}

                    <div className='d-flex justify-content-end gap-3 mt-3'>
                        <button type="button" onClick={() => setQuestionPop(false)} className='btn-closes'>Close</button>
                        <button type="button" className='btn-saves' onClick={handleSubmit}>Save</button>
                    </div>
                </form>
            </section>
        </section>
    );
};





